import template from './preview.pug';

export const TodoPreviewComponent = {
  template,
  bindings: {
    record: '<',
    isVisible: '<',
    onClose: '&',
    afterUpdate: '&?',
    afterNavigation: '&?'
  },
  controller: class TodoPreviewComponent {
    constructor(Todo, $async, $log, AlertBox) {
      'ngInject';

      this.Todo = Todo;
      this.$log = $log;
      this.AlertBox = AlertBox;

      this.moveToTrash = $async(this.moveToTrash.bind(this));
    }

    $onInit() {
      this.formState = 'show';
    }

    $onChanges({ record }) {
      if (record && record.currentValue) {
       this.formState = 'show';
      }
    }

    changeFormState(state) {
      if (state == 'edit') {
        this.record = angular.copy(this.record);
      }
      this.formState = state;
    }

    isFormState(state) {
      return this.formState == state;
    }

    destroy() {
      this.close();
      this.afterUpdate({ $event: {} });
    }

    close() {
      this.defaultState = (this.defaultState === 'closed' ? 'show': 'closed');
      this.onClose({ $event: {} });
    }

    update({ todo }) {
      try {
        if (todo && todo.id) {
          this.record = todo;
          this.AlertBox.addMessage('alert.updated.success', { type: 'success' });
          this.changeFormState('show');
          this.afterUpdate({ $event: {} });
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    async moveToTrash() {
      try {
        await this.Todo.moveToTrash(this.record.id);
        this.AlertBox.addMessage('alert.deleted.success', { type: 'success' });
        this.destroy();
      } catch (e) {
        this.$log.error(e);
      }
    }

  }
};
